// react components
import React from 'react'

// components
import {
} from 'components'

// data
import {
    contentTypeModelTypeSite,
    fieldTypeLayoutSite,
} from 'data'

// pages
import {
    TableColumnValue825,
} from 'pages'

// serializers
import {
    ContentTypeSettingsCustomTypes,
    ContentTypeSettingsTypes,
} from 'serializers/site'

// props
type TableColumn825Props = {
    addProfileColumn?: boolean
    conditionStyles?: any
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom?: ContentTypeSettingsCustomTypes
    field: string
    modalKey: number
    object: any
    profileObject: any | undefined
    refreshData?: () => void
    setFilter?: (e: any, f?: any) => void
}

// main
export const TableColumn825: React.FC<TableColumn825Props> = React.memo(({
    addProfileColumn,
    conditionStyles,
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    field,
    modalKey,
    object,
    profileObject,
    refreshData,
    setFilter,
}) => {

    const newColumn = field.split('__')[0]
    const fieldSettings = contentTypeSettings.field?.[newColumn]

    if (addProfileColumn && field === 'profile' && !fieldSettings) return null

    if (fieldSettings?.layout?.isHref) {
        return (
            <td
                className={`table-column-825 1 field-${fieldSettings?.fieldType || 'error'}`}
                style={conditionStyles}
            >
                {object[field] && (
                    <>
                        <a
                            className='tc-link-href'
                            href={object[field]}
                            rel='noopener noreferrer'
                            target='_blank'
                        >
                            <div className='tc-link-div'>
                                <TableColumnValue825
                                    contentType={contentType}
                                    contentTypeSettings={contentTypeSettings}
                                    contentTypeSettingsCustom={contentTypeSettingsCustom}
                                    field={field}
                                    fieldSettings={fieldSettings}
                                    object={object}
                                    profileObject={profileObject}
                                    refreshData={refreshData}
                                    setFilter={setFilter}
                                />
                            </div>
                        </a>
                    </>
                )}
            </td>
        )
    }

    return (
        <td
            className={`table-column-825 3 field-${fieldTypeLayoutSite[fieldSettings?.fieldType] || 'error'}`}
            style={conditionStyles}
        >

            <div className='tc-link-div'>
                <TableColumnValue825
                    contentType={contentType}
                    contentTypeSettings={contentTypeSettings}
                    contentTypeSettingsCustom={contentTypeSettingsCustom}
                    field={field}
                    fieldSettings={fieldSettings}
                    object={object}
                    profileObject={profileObject}
                    refreshData={refreshData}
                    setFilter={setFilter}
                />
            </div>
        </td>
    )
})
